import Immutable from 'immutable';

const initialState = Immutable.Map();

function setDevice(state) {
  let type = 'desktop';
  for (const device of ['phone', 'tablet']) {
    if (window.mobileDetect[device]() === true) {
      type = device;
    }
  }
  return state.set('type', type);
}

function setViewport(state) {
  return state
    .setIn(['viewport', 'height'], window.innerHeight)
    .setIn(['viewport', 'width'], window.innerWidth);
}

function init(state, _payload) {
  return setDevice(setViewport(state));
}

export default function reduce(state = initialState, { type, payload }) {
  return state.withMutations((mutableState) => {
    return (
      {
        INIT: init,
        VIEWPORT_CHANGED: setViewport,
      }[type] || (() => mutableState)
    )(mutableState, payload);
  });
}
